"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var canPublishCxEvent = function canPublishCxEvent() {
  return !process.env.IS_CYPRESS_TEST && !navigator.webdriver;
};

var _default = canPublishCxEvent;
exports.default = _default;